"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const _333mbfIcon = createIcon({
  displayName: "_333mbfIcon",
  viewBox: "0 0 500 500",
  path: (
    <>
      <path
        d="m32.565 107.062h40v40h-40z"
        transform="matrix(.7071 -.7071 .7071 .7071 -74.4511 74.3862)"
        fill="currentColor"
      />
      <path
        d="m72.164 67.464h39.999v40.001h-39.999z"
        transform="matrix(.7071 -.7071 .7071 .7071 -34.8528 90.788)"
        fill="currentColor"
      />
      <path
        d="m111.761 27.866h39.999v40.001h-39.999z"
        transform="matrix(.7071 -.7071 .7071 .7071 4.746 107.1909)"
        fill="currentColor"
      />
      <path
        d="m72.305 146.519h40.001v40.001h-40.001z"
        transform="matrix(.7071 -.7071 .7071 .7071 -90.7112 114.0419)"
        fill="currentColor"
      />
      <path
        d="m111.903 106.922h40.001v39.999h-40.001z"
        transform="matrix(.7071 -.7071 .7071 .7071 -51.1134 130.441)"
        fill="currentColor"
      />
      <path
        d="m151.501 67.323h40v40h-40z"
        transform="matrix(.7071 -.7071 .7071 .7071 -11.5154 146.8459)"
        fill="currentColor"
      />
      <path
        d="m111.974 186.046h39.999v40.001h-39.999z"
        transform="matrix(.7071 -.7071 .7071 .7071 -107.0435 153.6732)"
        fill="currentColor"
      />
      <path
        d="m151.572 146.448h39.999v40.001h-39.999z"
        transform="matrix(.7071 -.7071 .7071 .7071 -67.4445 170.067)"
        fill="currentColor"
      />
      <path
        d="m191.17 106.85h40.001v40.001h-40.001z"
        transform="matrix(.7071 -.7071 .7071 .7071 -27.8474 186.4691)"
        fill="currentColor"
      />
      <path
        d="m32.458 341.045h40.001v40.001h-40.001z"
        transform="matrix(.7071 -.7071 .7071 .7071 -239.9365 142.8461)"
        fill="currentColor"
      />
      <path
        d="m72.056 301.447h39.999v40.001h-39.999z"
        transform="matrix(.7071 -.7071 .7071 .7071 -200.3379 159.248)"
        fill="currentColor"
      />
      <path
        d="m111.654 261.849h39.999v40.001h-39.999z"
        transform="matrix(.7071 -.7071 .7071 .7071 -160.7393 175.6498)"
        fill="currentColor"
      />
      <path
        d="m72.197 380.502h40.001v40.001h-40.001z"
        transform="matrix(.7071 -.7071 .7071 .7071 -256.1935 182.498)"
        fill="currentColor"
      />
      <path
        d="m111.796 340.905h40v39.998h-40z"
        transform="matrix(.7071 -.7071 .7071 .7071 -216.5901 198.8882)"
        fill="currentColor"
      />
      <path
        d="m151.394 301.307h39.999v39.999h-39.999z"
        transform="matrix(.7071 -.7071 .7071 .7071 -176.9962 215.2961)"
        fill="currentColor"
      />
      <path
        d="m111.867 420.029h39.998v40h-39.998z"
        transform="matrix(.7071 -.7071 .7071 .7071 -272.525 222.1251)"
        fill="currentColor"
      />
      <path
        d="m151.465 380.43h39.999v40.001h-39.999z"
        transform="matrix(.7071 -.7071 .7071 .7071 -232.9237 238.5201)"
        fill="currentColor"
      />
      <path
        d="m191.062 340.833h40.001v40.001h-40.001z"
        transform="matrix(.7071 -.7071 .7071 .7071 -193.3268 254.9223)"
        fill="currentColor"
      />
      <path
        d="m443.368 249.918c4.93-76.658 73.936-190.163-58.732-190.163-111.139 0-118.596 96.192-118.596 190.163 0 84.969 4.043 186.586 106.525 190.163 142.873 4.986 76.282-104.975 70.803-190.163z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default _333mbfIcon;
